import { render, staticRenderFns } from "./PendingApprovalDetail.vue?vue&type=template&id=23e7f1f8&scoped=true"
import script from "./PendingApprovalDetail.vue?vue&type=script&lang=js"
export * from "./PendingApprovalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7f1f8",
  null
  
)

export default component.exports